<template>
  <aside
    class="qa-sidebar"
    :class="{ 'qa-sidebar--collapsed': collapsed }">
    <button
      type="button"
      class="qa-sidebar__toggle"
      :aria-expanded="!collapsed"
      :aria-label="collapsed ? 'Развернуть замечания' : 'Свернуть замечания'"
      :title="collapsed ? 'Развернуть замечания' : 'Свернуть замечания'"
      @click="collapsed = !collapsed">
      <left-outlined v-if="collapsed" />
      <right-outlined v-else />
    </button>
    <div
      v-show="!collapsed"
      class="qa-sidebar__content">
      <slot />
    </div>
  </aside>
</template>

<script setup>
import { ref } from 'vue';
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue';

const collapsed = ref(false);
</script>

<style scoped>
.qa-sidebar {
  position: relative;
  flex: 0 0 380px;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding: 12px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
}
.qa-sidebar--collapsed {
  flex-basis: 28px;
  padding: 0;
  border: 0;
  background: transparent;
}
.qa-sidebar__toggle {
  position: absolute;
  z-index: 2;
  left: -28px;
  top: 24px;
  width: 28px;
  height: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 6px 0 0 6px;
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
}
.qa-sidebar__toggle:hover,
.qa-sidebar__toggle:focus-visible { color: #1677ff; border-color: #1677ff; }
.qa-sidebar--collapsed .qa-sidebar__toggle { left: 0; }
.qa-sidebar__content { overflow-y: auto; min-height: 0; }
</style>
